export default "__VITE_ASSET__gYxIqnc2__"